module.exports = __webpack_public_path__ + "static/media/placeholder3.2cbfaee1.png";